module.exports = __webpack_public_path__ + "prod/20260721094810/img/url-app.d88da72d.png";